import { createContext, useContext } from 'react';

export type CustomTileHostRegistry = {
  slots: Map<string, HTMLElement>;
  hosts: Map<string, HTMLElement>;
  registerSlot: (name: string, element: HTMLElement) => () => void;
  registerHost: (name: string, element: HTMLElement) => () => void;
};

const register = (entries: Map<string, HTMLElement>, name: string, element: HTMLElement) => {
  entries.set(name, element);

  return () => {
    // A grid slot and a content slot swap within one commit; only the owner may remove itself.
    if (entries.get(name) === element) {
      entries.delete(name);
    }
  };
};

export const createCustomTileHostRegistry = (): CustomTileHostRegistry => {
  const slots = new Map<string, HTMLElement>();
  const hosts = new Map<string, HTMLElement>();

  return {
    slots,
    hosts,
    registerSlot: (name, element) => register(slots, name, element),
    registerHost: (name, element) => register(hosts, name, element),
  };
};

export const CustomTileHostContext = createContext<CustomTileHostRegistry | null>(null);

export const useCustomTileHostRegistry = () => useContext(CustomTileHostContext);
